import GoogleSigninButton from './GoogleSigninButton.class';
import { defineComponent, inject, onMounted, onUnmounted } from 'vue';
import type { IIncentiveV2Store } from '@/domain/dto/store.incentive-v2.interfaces';
import { setupComponent } from '@studyportals/vue-platform';
export default defineComponent({
	props: {
		template: {
			type: String,
			default: 'Small'
		},
		isRegistration: {
			type: Boolean,
			default: true
		}
	},
	setup: (props) => {
		const store = inject<IIncentiveV2Store>('incentiveV2Store');
		if(!store) {
			throw new Error('incentiveV2Store is not provided');
		}
		const component = new GoogleSigninButton(store, props.isRegistration, props.template);
		onMounted(component.mounted.bind(component));
		onUnmounted(component.unmount.bind(component));
		return setupComponent(component);
	}
});